// extracted by mini-css-extract-plugin
module.exports = {"root":"ad-a-module--root--3nDG4","imgWrapper":"ad-a-module--imgWrapper--2Qalf","img":"ad-a-module--img--2zMqu"};